<template lang="pug">
  y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 fluid scrollable :fullscreen="$vuetify.breakpoint.xsOnly" content-class="round-2xl" persistent)
    v-card
      template(v-if="noAudiences")
        .pa-8
          .text-xl.font-medium.mb-4 Are you sure you want to delete the status?
          .text-md Click “Confirm” to proceed

      template(v-else)
        v-card-title.pa-4
          v-spacer 
          .text-xl.font-bold.ml-10 Remove status
          v-spacer
          v-btn(icon @click="showDialog = false" color="primary" small)
            v-icon mdi-close
        v-divider

        v-card-text.pa-8.primary--text
          .text-md.font-semibold You have {{ status.total_customers }} audience with this status
          .text-md.mb-6 In order to remove the status, the audience data need to be transferred to other status. Choose the status that you want to transfer the data into:
          .text-sm.font-semibold.neutral500--text.mb-2 Transfer to
          v-select.round-xl.text-md(hide-details append-icon="$yzi-chevron-down" :menu-props="{ bottom: true, offsetY: true, nudgeBottom: 8, rounded: 'md' }" outlined placeholder="Choose status" :items="tranferStatuses" item-text="name" item-value="id" v-model="transferStatus")
      v-divider

      v-card-actions.px-6.py-3
        v-btn.button-md.underline.ml-n4(@click="showDialog = false" color="primary" text) {{ $t('cancel') }}
        v-spacer
        v-btn.button-md.white--text(@click="confirm" color="danger500" depressed :loading="isLoading" :disabled="!noAudiences && transferStatus === null") {{ $t('confirm') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'DeleteStatusDialog',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    status: {
      type: Object,
      default: () => {}
    },
    statuses: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    isLoading: false,
    name: '',
    transferStatus: null
  }),
  mounted () {
    this.name = this.status.name
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    noAudiences () {
      return this.status.total_customers === 0
    },
    tranferStatuses () {
      return this.statuses.filter(item => item.id !== this.status.id)
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    confirm () {
      let params = {}
      if (!this.noAudiences) {
        params = { transfer_to: this.transferStatus }
      }
      this.isLoading = true
      this.$axios.post(`/connect/${this.company.slug}/statuses/${this.status.id}/delete/`, params)
        .then(() => {
          this.showMessage(['success', 'Status deleted successfully'])
          this.showDialog = false
          this.$emit('deleted')
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>